import { CATALOG_API_URL } from 'config';
import { api } from 'utils';
import * as base from '../base';

const endpoints = {
  list: (siteDomain) => `${CATALOG_API_URL}/api/v1/${siteDomain}/catalog/category/`,
  flatList: (siteDomain) => `${CATALOG_API_URL}/api/v1/${siteDomain}/catalog/category/list/`,
  detail: (siteDomain) => (id) => `${CATALOG_API_URL}/api/v1/${siteDomain}/catalog/category/${id}/`,
};

export const categoryListLoad = (siteDomain) => (token, payload) => api.ListLoad(endpoints.list(siteDomain), token, payload);
export const categoryFlatListLoad = (siteDomain) => (token, payload) => api.ListLoad(endpoints.flatList(siteDomain), token, payload);
export const categoryDetailLoad = (siteDomain) => (token, { id }) => api.DetailLoad(endpoints.detail(siteDomain), token, { id });
export const categoryUpdate = (siteDomain) => (token, data) => api.Update(endpoints.list(siteDomain), endpoints.detail(siteDomain), token, data);
export const categoryDelete = (siteDomain) => (token, data) => api.Delete(endpoints.detail(siteDomain), token, data);

export const category = {
  state: {
    ...base.ListState,
    ...base.DetailState,
    ...base.EditState,
    ...base.DeleteState,

    title: 'Разделы',
    urls: {
      list: () => `/catalog/category`,
      detail: (id) => `/catalog/category/${id}`,
      groupList: (id) => `/catalog/cat/${id}`,
    },
  },
  reducers: {
    ...base.ListReducers,
    ...base.DetailReducers,
    ...base.EditReducers,
    ...base.DeleteReducers,
  },
  effects: (dispatch) => ({
    async listLoad(payload, rootState) {
      const apiRequest = categoryListLoad(rootState.site.activeDomain);
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'category', apiRequest);
    },

    async detailLoad(payload, rootState) {
      const apiRequest = categoryDetailLoad(rootState.site.activeDomain);
      await base.asyncDetailLoadRequest(dispatch, payload, rootState, 'category', apiRequest);
    },

    async update(payload, rootState) {
      const apiRequest = categoryUpdate(rootState.site.activeDomain);
      await base.asyncUpdateRequest(dispatch, payload, rootState, 'category', apiRequest);
    },

    async delete(payload, rootState) {
      const apiRequest = categoryDelete(rootState.site.activeDomain);
      await base.asyncDeleteRequest(dispatch, payload, rootState, 'category', apiRequest);
    },
  }),
};
